import { QUERY_PARAMS } from '@doda/common/src/constants/queryParams';
import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import { makeStaticUrl } from '@doda/common/src/logics/staticUrl';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { createUrl, removeUrlParams } from '@doda/common/src/utils/urlUtil';
import { Pager } from '@doda/io-react/pc';
import { JOB_COUNT_PER_PAGE } from 'constants/jobList';
import { useAppSelector } from '@doda/pc/src/redux/hooks';
import { totalJobCountSelector } from '@doda/pc/src/redux/features/jobList';
import { FC, MouseEvent } from 'react';
import { isCanonical } from '@doda/common/src/utils/seoUtil';
import { useCreateBaseUrl } from 'components/CardNavigationPanel/hooks/useCreateBaseUrl';

export const Pagination: FC = () => {
  const appQuery = useAppSelector(appQueryParamsSelector);
  const { page = '1', so } = appQuery;
  const totalCount = useAppSelector(totalJobCountSelector);
  const currentPage = Number(page);
  const maxPage = Math.ceil(totalCount / Number(so ?? JOB_COUNT_PER_PAGE));
  const baseUrl = useCreateBaseUrl();

  // 遷移先URL（prsrtは正規化しないのでundefined入れて除外する）
  const pageHref = (pageNum: number) => {
    const isStaticUrl = isCanonical(baseUrl);
    if (isStaticUrl) {
      const staticHref = makeStaticUrl(
        {
          ...appQuery,
          [QUERY_PARAMS.page]: pageNum === 1 ? undefined : pageNum,
          [QUERY_PARAMS.prsrt]: undefined,
          [QUERY_PARAMS.ss]: undefined,
          [QUERY_PARAMS.usrclk_searchList]: undefined,
          [QUERY_PARAMS.usrclk]: undefined,
          [QUERY_PARAMS.kwc]: undefined,
        },
        DODA_SITE_URL.jobSearchList
      );
      const pageerStaticURL = staticHref.replace(/,/g, '%2C');

      return pageerStaticURL;
    }

    // appQueryの型が受け付けないので変換する
    const url = createUrl({
      href: DODA_SITE_URL.jobSearchList,
      params: {
        ...Object.fromEntries(Object.entries(appQuery)),
        page: pageNum === 1 ? null : pageNum,
        ss: null,
      },
    });
    const pageerURL = url.replace(/,/g, '%2C');

    return pageerURL;
  };

  const onClickPager = (
    event: MouseEvent<HTMLAnchorElement, globalThis.MouseEvent>
  ) => {
    event.preventDefault();
    window.location.href = createUrl({
      href: removeUrlParams(event.currentTarget.href, [
        'usrclk',
        'usrclk_searchList',
      ]),
      params: { [QUERY_PARAMS.prsrt]: '1' },
    });
  };

  return (
    <Pager
      currentPage={currentPage}
      maxPage={maxPage}
      createPageHref={pageHref}
      onClickNext={(event) => onClickPager(event)}
      onClickPage={(event) => onClickPager(event)}
      onClickPrevious={(event) => onClickPager(event)}
    />
  );
};
